s<template>
<collapsible-panel v-if="!selectedType || selectedType == 'total-billing'" :external-toggle="panelOpen" v-on:panelRetract="panelOpen = false" panel-size="md">
	<template slot="panel">

		<field label="Landed in"
			col-class="stacked"
			:params="{type:'select',options:calendarYearOptions}"
			v-model="filtering.year">
		</field>

		<field label="Include"
			col-class="stacked"
			:params="{type:'checklist',options:[
				{text: 'Active Projects',value: 'active'},
				{text: 'Completed Projects',value: 'completed'},
				{text: 'Archived Projects',value: 'archived'}
			]}"
			v-model="filtering.include">
		</field>

		<alert v-if="filtering.include.length == 0" 
			:visible="true"
			message="Please choose some options"
			:unclosable="true"
			class="alert-warning p-1">		
		</alert>

		<field label="Customer" 
			col-class="stacked"
			:params="{type:'select',options:$store.customerOptions}"
			v-model="filtering.customerFilter">
		</field>

		<field label="Category"
			col-class="stacked"
			:params="{type:'select',options:categoryOptions}"
			v-model="filtering.categoryFilter">
		</field>

		<field label="With User"
			col-class="stacked"
			:params="{type:'select',options:userOptions(false)}"
			v-model="filtering.userFilter">
		</field>

		<button 
			v-if="!reportGeneratingInProgress" 
			class="btn btn-success" 
			style="width: 100%" 
			:disabled="filtering.include.length == 0"
			v-on:click="fetchProjects">
			<i class="fa fa-sync"></i>
			Generate Report
		</button>

		<progress-bar v-else
			message="Generating Report..."
			:progress-percent="fetchProgress">
		</progress-bar>
	</template>
	<template slot="main">

		<div class="d-flex justify-content-between align-items-center">
			<field label="Report Type"
				col-class="col-auto"
				:params="{type:'select',options:[
					{text: 'Total Billing',value:'total-billing'},
					{text: 'Billing Over Time',value: 'monthly-billing'}
				]}"
				v-model="localSelectedType"
				v-on:change="$emit('selectedTypeChange',$event)">
			</field>
			<field label="Data View"
				col-class="col-auto"
				:params="{type:'btn-group',buttons:[
					{text: 'Table',icon:'fa-table',value: true},
					{text: 'Graph',icon:'fa-chart-bar',value: false}
				]}"
				v-model="detailView">
			</field>

		</div>

		<h3>{{ reportHeading }}</h3>

		<div class="d-flex flex-row justify-content-between mb-3">
			<div class="d-flex flex-row flex-wrap">
				<button :disabled="panelOpen" class="btn btn-light mr-3" v-on:click="panelOpen = true">
					<i class="fa fa-filter"></i>
					Query Panel
				</button>

				<field
					style="margin-bottom: 0;"
					label="Compare By"
					col-class="col-auto"
					:params="{type:'btn-group',buttons:[
						{text:'Project',value:'job'},
						{text:'Category',value:'category'},
						{text:'Customer',value:'customer'},
						{text:'Personnel Role',value:'role'}
					]}"
					v-model="compareBy"
					v-on:change="compareByChange">
				</field>

				<field v-if="compareBy == 'role'"
					class="ml-2"
					label="Role"
					col-class="col-auto"
					:params="{type:'select',options:roleOptions}"
					v-model="compareByRole"
					v-on:change="compareByChange">
				</field>
			</div>

			<context-menu :menu-items="[
					{icon: 'fa-download',text: 'Export to CSV',clickFunction: 'exportResults'},
					{icon: 'fa-upload',text:'Import Project Costs', clickFunction: 'toggleCostsImportOn',disabled: showCostsImport}
				]"
				v-on:toggleCostsImportOn="showCostsImport = true"
				v-on:exportResults="exportReportResults">
			</context-menu>

		</div>

		<widget v-if="showCostsImport"
			class="mt-2"
			title="Import Project Costs" 
			icon="fa-upload" 
			header-button="fa-times" 
			v-on:headerButtonClick="showCostsImport = false">

			<p>You can upload a total of the each project's costs from an outside source, such as your accounting software. The upload file must be of .CSV type.</p>

			<div class="row">
				<div class="col-md-6">
					<h4>Fields:</h4>

					<ul>
						<li>Project #</li>
						<li>Total project Cost in $</li>
					</ul>

				</div>
				<div class="col-md-6">

					<p><strong>Example:</strong></p>

					<table class="spreadsheet-table mb-3">
						<tr>
							<th></th>
							<th>A</th>
							<th>B</th>
						</tr>
						<tr>
							<th>1</th>
							<td>007-20</td>
							<td>9574.22</td>
						</tr>
						<tr>
							<th>2</th>
							<td>134-20</td>
							<td>85965.00</td>
						</tr>
						<tr>
							<th>3</th>
							<td>135-20</td>
							<td>5703.22</td>
						</tr>
					</table>
				</div>
			</div>

			<field label="Effective Date"
				col-class="col-auto"
				:params="{type:'date'}"
				v-model="uploadCostsDate">
			</field>

			<div class="d-flex">
				<input type="file" class="form-control" v-on:change="setFile">
				<button :disabled="!uploadFile" class="btn btn-success" v-on:click="uploadCosts">
					Upload
				</button>
			</div>

			<!--<p>Instead of using the project costs recorded from {{$store.appName}}, you can upload a total of the each project's costs from an outside source, such as your accounting software. This will cause the report to ignore costs recorded against the project from within {{$store.appName}} (as gathered from Expenses, Labour & Equipment) and use your uploaded costs instead.</p>

			<p>You can always revert back to {{$store.appName}} totaled costs if you choose.</p>-->

		</widget>

		<table-list v-if="detailView"
			:record-name="tableRecordName"
			:fields="fields"
			:hide-record-count="true"
			:sortable="true"
			:records="mutatedProjects">
		</table-list>
		<div v-else>
			<div class="row">
				<div class="col-lg-12">
					<widget title="Revenue">
						<chart v-if="showCharts"
							type="bar"
							height="300" 
							:datasets="[
								{
									data: chartGrossRevenue,
									borderColor: '#008931',
									backgroundColor: '#008931',
									label: 'Gross Revenue'
								},
								{
									data: chartNetRevenue,
									backgroundColor: '#00b875',
									borderColor: '#00b875',
									label: 'Net Revenue'
								}
							]"
							:labels="chartLabels"
							:options="chartOptions">		
						</chart>
					</widget>
				</div>
				<div class="col-lg-12">
					<widget title="Gross Profit">
						<chart v-if="showCharts"
							type="bar"
							height="300" 
							:data="chartGrossProfit"
							:labels="chartLabels"
							label="Gross Profit"
							background-color="#00b88f"
							border-color="#00b88f"
							border-width="0"
							:options="chartOptions">		
						</chart>
					</widget>
				</div>
			</div>
		</div>
	</template>
</collapsible-panel>
</template>

<script type="text/javascript">
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import ProgressBar from "@/components/ProgressBar"
import Widget from "@/components/Widget"
import ContextMenu from "@/layout_fragments/ContextMenu"
import Alert from "@/components/Alert"

import Chart from "@/components/Chart"

export default {
	name: "ReportsProjects",
	components: {
		CollapsiblePanel,
		Field,
		TableList,
		ProgressBar,
		Widget,
		ContextMenu,
		Chart,
		Alert
	},
	props: ["selectedType"],
	data() {
		return {
			localSelectedType: this.selectedType,
			invoices: [],
			projects: [],
			roles: [],
			reportBy: "filtered",
			filtering: {
				projectsListText: "",
				dateFrom: this.moment().subtract(30,"days").format("YYYY-MM-DD"),
				dateTo: null,
				year: this.moment().format("YYYY"),
				include: [],
				customerFilter: null,
				categoryFilter: null,
				userFilter: null
			},
			reportGeneratingInProgress: false,
			displayType: 'summary',
			detailType: 'list',
			fetchProgress: 0,
			panelOpen: true,
			compareBy: "job",
			compareByRole: "",
			showCharts: false,
			showCostsImport: false,
			uploadCostsDate: this.moment().format("YYYY-MM-DD"),
			uploadFile: null,
			detailView: false,
			reportHeading: "",
			showIncludeWarning: false
		}
	},
	watch: {
		selectedType() {
			this.localSelectedType = this.selectedType
		}
	},
	computed: {
		calendarYearOptions() {
			let earliestDate = this.moment(this.$store.company.created_at)
			let workingDate = this.moment()

			let options = []
			while (workingDate.isAfter(earliestDate)) {
				let year = workingDate.format("YYYY")

				options.push({
					text: year,
					value: year
				})

				workingDate.subtract(1,"year")
			}

			return options
		},
		chartOptions() {
			return {
				tooltips: {
					callbacks: {
						label(item,data) {
							let value = +item.value

							return "$ " + value.toCurrency()
						}
					}
					
				},
				scales: {
					yAxes: [{
						ticks: {
							callback(value,index,values) {
								let valueInK = value/1000

								let theValue = '$ '+ valueInK.toCurrency()

								return theValue.substring(0,theValue.length - 3)+"k"
							}
						}
					}]
				},
				events: ["click"]
			}
		},
		roleOptions() {
			return this.optionify(this.roles,"title")
		},
		chartLabels() {
			let vm = this

			return this.mutatedProjects.map(record => {

				if (this.compareBy == 'job') 
					return "#"+record.jobNum.text
				
				else if (this.compareBy == 'category') 
					return record.jobCategory
				
				else if (this.compareBy == 'customer') 
					return record.customerName
				
				else if (this.compareBy == 'role') 
					return record.userName

			})
		},
		chartGrossRevenue() {
			return this.mutatedProjects.map(record => {
				return record.grossRevSubtotalRaw
			})
		},
		chartNetRevenue() {
			return this.mutatedProjects.map(record => {
				return record.netRevenueRaw
			})
		},
		chartGrossProfit() {
			return this.mutatedProjects.map(record => {
				return record.grossProfitRaw
			})
		},
		mutatedProjects() {
			let vm = this

			let jobs = this.projects.filter(job => job != false).map(job => {

				if (vm.compareBy == "job") {
					let truncatedName = job.job_name

					if (truncatedName.length > 25)
						truncatedName = truncatedName.substr(0,25)+"..."

					job.jobName = truncatedName
					job.jobNum = {text:job.job_num,link:'/project/'+job.slug+"/dashboard"}

					job.jobCategory = ""
					if ("Category" in job && job.Category)
						job.jobCategory = job.Category.name

					job.customerName = ""
					if ("Customer" in job && job.Customer)
						job.customerName = job.Customer.name
				}

				let grossRevBase = 0, grossRevChanges = 0, holdback = 0
				
				if (job.JobInvoice && job.JobInvoice.length > 0) {
					let inv = job.JobInvoice[job.JobInvoice.length - 1]

					inv.JobInvoiceTask.forEach(task => {
						if (job && "JobTask" in job && job.JobTask) {
							if (task.task_id > 0) {
								let jobTask = job.JobTask.find(jobTask => jobTask.id == task.task_id)

								if (jobTask) 
									grossRevBase += +task.qty * +jobTask.unit_value
								
							}
							else {
								let jobChangeQuote = false
								if ("JobChangeOrder" in job)
									jobChangeQuote = job.JobChangeOrder.find(quote => quote.id == task.quote_id)

								if (jobChangeQuote)
									grossRevChanges += +task.qty * +jobChangeQuote.pretax_total
							}
						}
					},0)

					holdback += +inv.holdback_percentage * +inv.pretax_total
					
				}

				//calc total value
				let totalValue = 0
				if (job.JobTask)
					totalValue = job.JobTask.reduce((acc,task) => (+task.unit_value * +task.qty) + acc,0)

				let totalEstimatedCost = 0
				if (job.JobEstimate) {
					let labour = [], materials = [], equipment = []

					try {
						labour = JSON.parse(job.JobEstimate[0].labour_json)
					}
					catch (e) {}
					try {
						materials = JSON.parse(job.JobEstimate[0].materials_json)
					}
					catch (e) {}
					try {
						equipment = JSON.parse(job.JobEstimate[0].equipment_json)
					}
					catch (e) {}

					let labourCost = labour.reduce((acc,type) => acc + type.costAllowedRaw,0)
					let materialsCost = materials.reduce((acc, mat) => acc + mat.costAllowedRaw,0)
					let equipmentCost = equipment.reduce((acc,eq) => acc + eq.costAllowedRaw,0)

					totalEstimatedCost = labourCost + materialsCost + equipmentCost
				}

				let grossRevSubtotal = grossRevBase + grossRevChanges

				let netRevenue = grossRevSubtotal - holdback

				let projectCost = 0
				if (job.actual_project_cost)
					projectCost = +job.actual_project_cost

				let grossProfit = grossRevSubtotal - projectCost

				let grossProfitPercent = 0
				if (grossProfit > 0 && projectCost > 0)
					grossProfitPercent = grossProfit / projectCost * 100

				let estCostToComplete = totalValue - grossRevBase

				let jobCost = +job.actual_project_cost

				let percentComplete = 0
				if (totalValue > 0)
					percentComplete = grossRevBase / totalValue * 100

				job.totalValue = totalValue

				job.grossRevBase = grossRevBase
				job.grossRevChanges = grossRevChanges

				job.grossRevSubtotalRaw = grossRevSubtotal,
				job.grossRevSubtotal = grossRevSubtotal
				job.holdback = holdback
				job.netRevenueRaw = netRevenue
				job.netRevenue = netRevenue

				job.jobCost = jobCost
				job.grossProfitRaw = grossProfit
				job.grossProfit = grossProfit
				job.grossProfitPercent = grossProfitPercent
				job.percentComplete = percentComplete
				job.estCostToComplete = estCostToComplete
				job.totalEstimatedCost = totalEstimatedCost

				return job
			})

			let groupedRecords = []

			//compare by
			if (vm.compareBy == 'role' && vm.compareByRole) {
				//generate a list of users with matching role
				let userList = []
				jobs.forEach(job => {
					let index = -1, foundRole

					job.JobPersonnelRole.filter(role => role.id == vm.compareByRole).forEach(role => {
						index = groupedRecords.findIndex(userInList => userInList.user_id == role.user_id && userInList.roleTitle == role.title)
						foundRole = vm.cloneObj(role) //scoop up a role that matches
					})
					if (index == -1 && foundRole) {
						let obj = vm.cloneObj(job)

						obj.user_id = foundRole.user_id
						obj.userName = foundRole.User.first_name+" "+foundRole.User.last_name
						obj.roleTitle = foundRole.title

						groupedRecords.push(obj)
					}
					else if (job && typeof groupedRecords[index] != 'undefined') {
						groupedRecords[index].grossRevBase += job.grossRevBase
						groupedRecords[index].grossRevChanges += job.grossRevChanges
						groupedRecords[index].grossRevSubtotalRaw += job.grossRevSubtotal
						groupedRecords[index].grossRevSubtotal += job.grossRevSubtotal
						groupedRecords[index].holdback += job.holdback
						groupedRecords[index].netRevenueRaw += job.netRevenue,
						groupedRecords[index].netRevenue += job.netRevenue,
						groupedRecords[index].grossProfitRaw += job.grossProfit,
						groupedRecords[index].grossProfit += job.grossProfit
						groupedRecords[index].grossProfitPercent = groupedRecords[index].grossProfit / groupedRecords[index].jobCost * 100
						groupedRecords[index].percentComplete = job.grossRevBase / groupedRecords[index].totalValue * 100
					}

				})
			}
			else if (vm.compareBy != 'project') {
				jobs.forEach(job => {

					let index = -1
					if (vm.compareBy == 'category') 
						index = groupedRecords.findIndex(record => record.category_id == job.category_id)
					else if (vm.compareBy == 'customer')
						index = groupedRecords.findIndex(record => record.customer_id == job.customer_id)

					if (index >= 0) {
						//already found, add it to running total
						groupedRecords[index].grossRevBase += job.grossRevBase
						groupedRecords[index].grossRevChanges += job.grossRevChanges
						groupedRecords[index].grossRevSubtotalRaw += job.grossRevSubtotal
						groupedRecords[index].grossRevSubtotal += job.grossRevSubtotal
						groupedRecords[index].holdback += job.holdback
						groupedRecords[index].netRevenueRaw += job.netRevenue,
						groupedRecords[index].netRevenue += job.netRevenue,
						groupedRecords[index].grossProfitRaw += job.grossProfit,
						groupedRecords[index].grossProfit += job.grossProfit
						groupedRecords[index].grossProfitPercent = groupedRecords[index].grossProfit / groupedRecords[index].jobCost * 100
						groupedRecords[index].percentComplete = job.grossRevBase / groupedRecords[index].totalValue * 100
					}
					else 
						//not found, push
						groupedRecords.push(job)
				})
			}
			else
				groupedRecords = jobs

			//format fields for pretty display: currency fields, add progress bars, etc
			return groupedRecords.map(job => {
				vm.fields.forEach(field => {
					if (field.key == 'percentComplete') {
						job[field.key] = vm.renderInlineProgressBar(job[field.key])
					}
					else if (field.key == "grossProfitPercent") {
						job.grossProfitPercent = job.grossProfitPercent.round(1)
						let color = ""
						if (job.grossProfitPercent <= 0)
							color = "red"
						else if (job.grossProfitPercent > 0 && job.grossProfitPercent < 10)
							color = "#ff8338"
						else if (job.grossProfitPercent > 10 && job.grossProfitPercent < 30)
							color = "#87a903"
						else
							color = "#50bd00"

						job.grossProfitPercent = "<span style='color:"+color+"'>"+job.grossProfitPercent+"%</span>"
					}
					else if (typeof job[field.key] != 'undefined' && job[field.key]) {
						if (field.align == "right") //currency fields
							job[field.key] = job[field.key].toCurrency()
						else if (field.align == "center") //percentage fields
							job[field.key] = job[field.key].round(1)+"%"
					}
					else
						job[field.key] = ""
				})

				return job
			})
		},
		mutatedToProjects() {
			let vm = this

			let jobs = []

			this.invoices.forEach(inv => {

				let job = inv.Job

				let grossRevBase = 0, grossRevChanges = 0
				inv.JobInvoiceTask.forEach(task => {
					if (job && "JobTask" in job && job.JobTask) {
						let jobTask = job.JobTask.find(jobTask => jobTask.id == task.task_id)

						if (jobTask) {
							let changeValue = +task.qty * +jobTask.unit_value

							if (jobTask.is_change == 0)
								grossRevBase += changeValue
							else
								grossRevChanges += changeValue
						}
					}
				},0)

				let grossRevSubtotal = grossRevBase + grossRevChanges

				let holdback = +inv.holdback_percentage * grossRevSubtotal

				let netRevenue = grossRevSubtotal - holdback

				let projectCost = 0
				if (job.actual_project_cost)
					projectCost = +job.actual_project_cost

				let grossProfit = grossRevSubtotal - projectCost

				let grossProfitPercent = 0
				if (grossProfit > 0 && projectCost > 0)
					grossProfitPercent = grossProfit / projectCost * 100

				let jobIndex = jobs.findIndex(job => job.id == inv.Job.id)

				if (jobIndex >= 0) {
					//job already exists, we need to add to it
					jobs[jobIndex].grossRevBase += grossRevBase
					jobs[jobIndex].grossRevChanges += grossRevChanges
					jobs[jobIndex].grossRevSubtotal = grossRevSubtotal
					jobs[jobIndex].holdback += holdback
					jobs[jobIndex].netRevenue = netRevenue,
					jobs[jobIndex].grossProfit = grossProfit
					jobs[jobIndex].grossProfitPercent = grossProfitPercent
					jobs[jobIndex].percentComplete = grossRevBase / jobs[jobIndex].totalValue * 100
				}
				else if (job) {
					//push job to jobs list

					//calc total value
					let totalValue = 0
					if (job.JobTask)
						totalValue = job.JobTask.reduce((acc,task) => (+task.unit_value * +task.qty) + acc,0)

					let totalEstimatedCost = 0
					if (job.JobEstimate) {
						let labour = [], materials = [], equipment = []

						try {
							labour = JSON.parse(job.JobEstimate[0].labour_json)
						}
						catch (e) {}
						try {
							materials = JSON.parse(job.JobEstimate[0].materials_json)
						}
						catch (e) {}
						try {
							equipment = JSON.parse(job.JobEstimate[0].equipment_json)
						}
						catch (e) {}

						let labourCost = labour.reduce((acc,type) => acc + type.costAllowedRaw,0)
						let materialsCost = materials.reduce((acc, mat) => acc + mat.costAllowedRaw,0)
						let equipmentCost = equipment.reduce((acc,eq) => acc + eq.costAllowedRaw,0)

						totalEstimatedCost = labourCost + materialsCost + equipmentCost
					}

					let truncatedName = job.job_name

					if (truncatedName.length > 25)
						truncatedName = truncatedName.substr(0,25)+"..."

					let jobObj = {
						id: job.id,
						category_id: job.category_id,
						customer_id: job.customer_id,
						personnel_role_id: job.JobPersonnelRole ? job.JobPersonnelRole.personnel_role_id : 0,
						jobNum: {text:job.job_num,link:'/project/'+job.slug+"/dashboard"},
						jobName: truncatedName,
						customerPO: job.customer_po,
						customerName: job.Customer.name ? job.Customer.name : '[no customer set]',
						dateLanded: vm.formatDate(job.date_landed),
						jobCost: job.actual_project_cost,
						jobCategory: job.Category.name,
						isBonded: job.is_bonded == 1 ? true : false,
						totalEstimatedCost,
						totalValue,
						grossRevBase,
						grossRevChanges,
						grossRevSubtotalRaw: grossRevSubtotal,
						grossRevSubtotal,
						holdback,
						netRevenueRaw: netRevenue,
						netRevenue,
						jobCost: +job.actual_project_cost,
						grossProfitRaw: grossProfit,
						grossProfit,
						grossProfitPercent,
						percentComplete: grossRevBase / totalValue * 100,
						estCostToComplete: totalValue - grossRevBase,
						JobPersonnelRole: job.JobPersonnelRole
					}
					jobs.push(jobObj)
				}

				return inv
			})

			let groupedRecords = []

			//compare by
			if (vm.compareBy == 'role' && vm.compareByRole) {
				//generate a list of users with matching role
				let userList = []
				jobs.forEach(job => {
					let index = -1, foundRole

					job.JobPersonnelRole.filter(role => role.id == vm.compareByRole).forEach(role => {
						index = groupedRecords.findIndex(userInList => userInList.user_id == role.user_id && userInList.roleTitle == role.title)
						foundRole = vm.cloneObj(role) //scoop up a role that matches
					})
					if (index == -1 && foundRole) {
						let obj = vm.cloneObj(job)

						obj.user_id = foundRole.user_id
						obj.userName = foundRole.User.first_name+" "+foundRole.User.last_name
						obj.roleTitle = foundRole.title

						groupedRecords.push(obj)
					}
					else if (job) {
						groupedRecords[index].grossRevBase += job.grossRevBase
						groupedRecords[index].grossRevChanges += job.grossRevChanges
						groupedRecords[index].grossRevSubtotalRaw += job.grossRevSubtotal
						groupedRecords[index].grossRevSubtotal += job.grossRevSubtotal
						groupedRecords[index].holdback += job.holdback
						groupedRecords[index].netRevenueRaw += job.netRevenue,
						groupedRecords[index].netRevenue += job.netRevenue,
						groupedRecords[index].grossProfitRaw += job.grossProfit,
						groupedRecords[index].grossProfit += job.grossProfit
						groupedRecords[index].grossProfitPercent = groupedRecords[index].grossProfit / groupedRecords[index].jobCost * 100
						groupedRecords[index].percentComplete = job.grossRevBase / groupedRecords[index].totalValue * 100
					}

				})
			}
			else if (vm.compareBy != 'project') {

				jobs.forEach(job => {

					let index = -1
					if (vm.compareBy == 'category') {
						index = groupedRecords.findIndex(record => record.category_id == job.category_id)

					}
					else if (vm.compareBy == 'customer')
						index = groupedRecords.findIndex(record => record.customer_id == job.customer_id)

					if (index >= 0) {
						//already found, add it to running total
						groupedRecords[index].grossRevBase += job.grossRevBase
						groupedRecords[index].grossRevChanges += job.grossRevChanges
						groupedRecords[index].grossRevSubtotalRaw += job.grossRevSubtotal
						groupedRecords[index].grossRevSubtotal += job.grossRevSubtotal
						groupedRecords[index].holdback += job.holdback
						groupedRecords[index].netRevenueRaw += job.netRevenue,
						groupedRecords[index].netRevenue += job.netRevenue,
						groupedRecords[index].grossProfitRaw += job.grossProfit,
						groupedRecords[index].grossProfit += job.grossProfit
						groupedRecords[index].grossProfitPercent = groupedRecords[index].grossProfit / groupedRecords[index].jobCost * 100
						groupedRecords[index].percentComplete = job.grossRevBase / groupedRecords[index].totalValue * 100
					}
					else 
						//not found, push
						groupedRecords.push(job)
				})
			}
			else
				groupedRecords = jobs

			//format fields for pretty display: currency fields, add progress bars, etc
			return groupedRecords.map(job => {
				vm.fields.forEach(field => {
					if (field.key == 'percentComplete') {
						job[field.key] = vm.renderInlineProgressBar(job[field.key])
					}
					else if (field.key == "grossProfitPercent") {
						job.grossProfitPercent = job.grossProfitPercent.round(1)
						let color = ""
						if (job.grossProfitPercent <= 0)
							color = "red"
						else if (job.grossProfitPercent > 0 && job.grossProfitPercent < 10)
							color = "#ff8338"
						else if (job.grossProfitPercent > 10 && job.grossProfitPercent < 30)
							color = "#87a903"
						else
							color = "#50bd00"

						job.grossProfitPercent = "<span style='color:"+color+"'>"+job.grossProfitPercent+"%</span>"
					}
					else if (typeof job[field.key] != 'undefined' && job[field.key]) {
						if (field.align == "right") //currency fields
							job[field.key] = job[field.key].toCurrency()
						else if (field.align == "center") //percentage fields
							job[field.key] = job[field.key].round(1)+"%"
					}
					else
						job[field.key] = ""
				})

				return job
			})
		},
		tableRecordName() {
			return "Project"
		},
		fields() {
			let fields = [
				//{label: "Date Landed",key: "dateLanded"},
				{label: "Total Value",key: "totalValue",align:"right"},
				{label: "Total Est. Cost",key: "totalEstimatedCost",align:"right"},
				{label: "Gross Rev. (Changes)",key:"grossRevChanges",align:"right"},
				{label: "Gross Rev. (Base)",key:"grossRevBase",align:"right"},
				{label: "Gross Rev. (Subtotal)",key:"grossRevSubtotal",align:"right"},
				{label: "Holdback",key:"holdback",align:"right"},
				{label: "Net Revenue",key: "netRevenue",align:"right"},
				{label: "Cost",key: "jobCost",align:"right"},
				{label: "Gross Profit",key:"grossProfit",align:"right"},
				{label: "Gross Profit %",key: "grossProfitPercent",align:"center"},
				{label: "% Compl.",key: "percentComplete"},
				{label: "Est. Cost to Compl.", key: "estCostToComplete",align:"right"}
			]

			if (this.compareBy == 'job') {
				let jobFields = [
					{label: "Project #",key:'jobNum',type:'link'},
					{label: "Project Name",key:'jobName'},
					{label: "Category",key:"jobCategory"},
					{label: "Customer",key: "customerName"}
				]

				return jobFields.concat(fields)
			}
			else if (this.compareBy == 'category') {
				let catFields = [
					{label: "Category",key:"jobCategory"}
				]

				return catFields.concat(fields)
			}
			else if (this.compareBy == 'customer') {
				let catFields = [
					{label: "Customer",key: "customerName"}
				]

				return catFields.concat(fields)
			}
			else if (this.compareBy == 'role') {
				let catFields = [
					{label: "Name",key: "userName"},
					{label: "Role",key: "roleTitle"}
				]

				return catFields.concat(fields)
			}
			else
				return fields
		},
	},
	methods: {
		setFile(evt) {
			if (evt.target.files.length > 0)
				this.uploadFile = evt.target.files[0]
		},
		setReportHeading() {
			let compiledHeading = "Total Billing "

			let dateRange = ""
			if (this.filtering.dateFrom && this.filtering.dateTo) {
				dateRange = " between "+this.moment(this.filtering.dateFrom).format("MMM D, YYYY")+" and "+this.moment(this.filtering.dateTo).format("MMM D, YYYY")
			}
			else {
				if (this.filtering.dateFrom)
					dateRange += " from "+this.moment(this.filtering.dateFrom).format("MMM D, YYYY")

				if (this.filtering.dateTo)
					dateRange += " to "+this.moment(this.filtering.dateTo).format("MMM D, YYYY")
			}

			compiledHeading += dateRange

			if (this.filtering.customerFilter > 0) {
				let customer = this.$store.customerOptions.find(opt => opt.value == this.filtering.customerFilter)
				if (customer)
					compiledHeading += " for "+customer.text
			}

			if (this.filtering.categoryFilter > 0) {
				let cat = this.categoryOptions.find(opt => opt.value == this.filtering.categoryFilter)

				if (cat)
					compiledHeading += " in "+cat.text
			}

			this.reportHeading = compiledHeading
		},
		exportReportResults() {
			let headerRow = this.fields.map(field => field.label)

			let vm = this

			let rows = this.mutatedProjects.map(row => {
				let renderedRow = []
				vm.fields.forEach(field => {
					if (!row[field.key])
						renderedRow.push("")
					else if (field.key == 'percentComplete') {
						let percentCompleteRaw = row.grossRevBase / row.groupedRecords[index].totalValue * 100
						percentCompleteRaw = percentCompleteRaw.round(1)
						renderedRow.push(percentCompleteRaw)
					}
					else
						renderedRow.push(row[field.key])
				})
				return renderedRow
			})

			rows.unshift(headerRow)

			let filename = "ProjectsReport_by_"+this.compareBy+".csv"

			this.exportToCSV(filename,rows)
		},
		uploadCosts() {
			let vm = this

			let f = this.uploadFile;

			let reader = new FileReader();

			let fileValid = true

			let allowedMimes = [
				"text/plain",
				"text/csv",
				"application/vnd.ms-excel"
			]

			//check file extension type
			if (allowedMimes.indexOf(f.type) == -1)
				vm.alertFail("Invalid file format! File must be a CSV")

			else {

				 // Closure to capture the file information.
				reader.onload = (theFile => {
					return e => {
						
						let csvObj = vm.CSVToArray(e.target.result)

						//check if last row is a blank, if so remove it
						if (csvObj[csvObj.length-1].length == 1)
							csvObj.splice(csvObj.length-1,1)

						let recordsPayload, resource, numFields

						numFields = 2

						//check appropriate number of fields per row
						csvObj.forEach(row => {
							if (row.length != numFields)
								fileValid = false
						})

						recordsPayload = csvObj.map(row => {
							return {
								job_num: row[0],
								date: vm.uploadCostsDate,
								actual_project_cost: row[1]
							}
						})
						
						if (fileValid) {
							vm.spinner(true)

							vm.postData("JobActualCostDatapoint/save-batch",{records: JSON.stringify(recordsPayload)}).then(response => {
								vm.alertSaved(response.data.records_saved+" projects updated successfully!")
								vm.spinner(false)
							})
						}
						else 
							vm.alertFail("Invalid CSV format! There must be "+numFields+" fields per row.")
						
					};
				})(f);

				reader.readAsText(f);
			}
		},
		compareByChange(value) {
			this.showCharts = false

			let vm = this
			this.$nextTick(() => {
				if (value == 'role' && this.roles.length == 0)
					this.fetchRoles()

				else
					vm.showCharts = true
			})
		},
		compileReport() {
			this.reportGeneratingInProgress = false
			this.showCharts = true
			this.reportFetched = true
			this.setReportHeading()
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			return new Promise((resolve,reject) => {
				let promises = [
					vm.fetchCustomers(true,false),
					vm.fetchJobCategories(),
					vm.fetchUsers(false,false,["id","slug","first_name","last_name"])
				]

				Promise.all(promises).then(responses => {
					vm.spinner(false)

					resolve()
				})
			})
		},
		fetchRoles() {
			let vm = this

			this.getJSON("JobPersonnelRole/get").then(response => {
				if (response.success) {
					vm.roles = response.data
					vm.showCharts = true
				}
			})
		},
		fetchJobInvoicesPage(page) {
			let vm = this

			let include = [
				{
					model: "JobInvoiceTask",
					fields: ["id","slug","task_id","qty","invoice_id"]
				},
				{
					model: "Job",
					fields: ["id","slug","category_id","customer_id","job_num","job_name","is_bonded","customer_po","date_landed","actual_project_cost","Customer"],
					include: [
						"Category",
						"JobTask",
						"JobEstimate",
						{model: "JobPersonnelRole", include: [{model: "User",fields: ["id","slug","first_name","last_name"]}]},
						{model: "Contact",fields:["id","slug","name"]},
					]
				}
			]

			let fields = [
				"id",
				"slug",
				"invoice_num",
				"revision_num",
				"is_active_version",
				"issue_date",
				"due_date",
				"pretax_total",
				"grand_total",
				"is_processed",
				"is_paid",
				"is_finalized",
				"holdback_percentage",
				"job_id"
			]

			let filters = [
				["is_active_version",1],
				["is_finalized",1]
			]
			if (vm.reportBy == 'filtered') {

				if (vm.filtering.dateFrom)
					filters.push(['issue_date >=',vm.filtering.dateFrom])

				if (vm.filtering.dateTo)
					filters.push(["issue_date <=",vm.filtering.dateTo])

				if (vm.filtering.customerFilter)
					filters.push(["Job.customer_id",vm.filtering.customerFilter])

				if (vm.categoryFilter)
					filters.push(["Job.category_id",vm.filtering.categoryFilter])
			}
			else {
				let jobNums = vm.projectsListText.split(/[ ,]+/).filter(Boolean)

				filters = [
					["job_num",jobNums]
				]
			}

			let params = {
				include,
				filters,
				fields
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("JobInvoice/get",params,true).then(response => {
					resolve(response)
				})
			})
		},
		fetchAllInvoicePages() {
			let vm = this

			let page = 1

			this.reportGeneratingInProgress = true
			this.showCharts = false

			vm.$nextTick(() => {

				vm.fetchJobInvoicesPage(page).then(response => {
					let numPages = response.meta.num_pages

					let cntResolves = 1;
					vm.fetchProgress = 1;

					vm.invoices = response.data

					if (numPages > 1) {

						for (var p = 2; p <= numPages; p++) {
							vm.fetchJobInvoicesPage(p).then(response => {

								cntResolves++

								vm.fetchProgress = Math.floor(cntResolves / numPages * 100)

								if (response)
									vm.invoices = vm.invoices.concat(response.data)

								if (vm.fetchProgress >= 100) {
									//COMPLETE
									vm.compileReport()
								}

							})
						}
					}
					else {
						//COMPLETE
						vm.compileReport()
					}
				})

					
			})	
		},
		fetchProjects(spinner) {
			let vm = this

			let filters = []
			let andFilters = [
				["is_lead",0]
			]

			if (this.filtering.year) {
				let startDate = this.filtering.year+"-01-01"
				let endDate = this.filtering.year+"-12-31"

				andFilters = [
					...andFilters,
					["date_landed >=",startDate],
					["date_landed <=",endDate]
				]
			}

			if (this.filtering.customerFilter) 
				andFilters.push(["customer_id",this.filtering.customerFilter])

			if (this.filtering.categoryFilter)
				andFilters.push(["category_id",this.filtering.categoryFilter])

			if (this.filtering.include.length == 3) {
				//all options are included
				filters = andFilters
			}
			else {
				
				//set up the or conditions for project status
				if (this.filtering.include.indexOf("active") >= 0) {
					filters = [
						...filters,
						["date_completed",null],
						["archived",0],
						...andFilters,
					]
				}
				
				if (this.filtering.include.indexOf("completed") >= 0) {

					let andOrFilter = ["date_completed !=", null,"or"]
					if (filters.length == 0)
						andOrFilter = ["date_completed !=", null]

					filters = [
						...filters,
						andOrFilter,
						["archived",0],
						...andFilters,
					]
				}

				if (this.filtering.include.indexOf("archived") >= 0) {

					let andOrFilter = ["archived",1,"or"]
					if (filters.length == 0)
						andOrFilter = ["archived",1]

					filters = [
						...filters,
						andOrFilter,
						...andFilters
					]
				}
			}

			let params = {
				filters,
				fields: ["id","job_num","job_name","actual_project_cost","category_id","customer_id","date_landed","archived","date_completed","Customer"],
				include: [
					{
						model: "JobInvoice",
						fields: ["id","slug","pretax_total","is_active_version","is_finalized","invoice_num","holdback_percentage","holdback_release","grand_total","issue_date","job_id"],
						filters: [
							["is_active_version",1],
							["is_finalized",1]
						],
						include: [{
							model: "JobInvoiceTask",
							fields: ["id","slug","task_id","qty","invoice_id","task_id","quote_id"]
						}]
					}, 
					{
						model: "Contact",
						fields: ["id","slug","name"]
					},
					{model: "JobPersonnelRole", include: [{model: "User",fields: ["id","slug","first_name","last_name"]}]},
					"JobTask",
					"JobEstimate",
					"Category",
					"JobChangeOrder"
				]
			}

			this.reportGeneratingInProgress = true
			this.showCharts = false

			if (spinner)
				this.spinner(true)

			this.getJSON("Job/get",params).then(response => {
				if (spinner)
					vm.spinner(false)

				vm.reportGeneratingInProgress = false
				vm.showCharts = true

				if (response.success)
					vm.projects = response.data
			})
		}
	},
	created() {
		this.fetchData()

		if ("report_type" in this.$route.params)
			this.selectedType = this.$route.params.report_type
	}
}
</script>